export default __webpack_public_path__ + "5f1f982eecdcb4877a5832bd402de030.svg";